'use client';

import { PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import { Canvas } from '@react-three/fiber';
import cx from 'clsx';

interface CanvasWrapperProps extends PropsWithChildren {
  className?: string;
}

const CanvasWrapper = ({ children, className }: CanvasWrapperProps) => (
  <Box className={cx(className)}>
    <Canvas camera={{ position: [0, 0, 6], fov: 50 }} dpr={[1, 2]}>
      {children}
    </Canvas>
  </Box>
);

export default CanvasWrapper;
